import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import 'utils/permission'
import 'bootstrap/dist/css/bootstrap.css'
import './assets/fonts/iconfont.css'
import store from './store'
import router from './router'
import './assets/css/common.scss'

import promise from 'es6-promise';
promise.polyfill();

var sendUrl = "https://odr.earbitration.org.cn/sender/";
export default sendUrl;

Vue.prototype.$sendUrl = sendUrl

import Element, { Message } from 'element-ui';
function MyMessage(option) {
  Message.closeAll()
  Message(option)
}
MyMessage.success = function (option) {
  Message.closeAll()
  Message.success(option)
}
MyMessage.warning = function (option) {
  Message.closeAll()
  Message.warning(option)
}
MyMessage.error = function (option) {
  Message.closeAll()
  Message.error(option)
}
MyMessage.info = function (option) {
  Message.closeAll()
  Message.info(option)
}
Vue.use(Element);
Vue.prototype.$message = MyMessage;

import { LayoutPlugin, NavbarPlugin, LinkPlugin } from 'bootstrap-vue';
Vue.use(LinkPlugin);
Vue.use(LayoutPlugin);
Vue.use(NavbarPlugin);

import moment from 'moment'
Vue.prototype.$moment = moment;
Vue.prototype.$moneyFormat = function (number, decimals, dec_point, thousands_sep) {
  /*
  * 参数说明：
  * number：要格式化的数字
  * decimals：保留几位小数
  * dec_point：小数点符号
  * thousands_sep：千分位符号
  * */
  number = (number + '').replace(/[^0-9+-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
    dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return '' + Math.ceil(n * k) / k;
    };

  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  var re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, "$1" + sep + "$2");
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
};

Vue.config.productionTip = false;
// 表单验证
import VeeValidate, { Validator } from 'vee-validate';
Validator.extend('phone', {
  getMessage: () => '手机号格式错误',
  validate: value => {
    return /^1[345789]\d{9}$/.test(value)
  }
})
Validator.extend('age', {
  getMessage: () => '年龄最大为120',
  validate: value => {
    return /^\d$|^[1-9]\d*$/.test(value) && value <= 120
  }
})
Validator.extend('files', {
  getMessage: () => '文件格式错误或大小超过10Mb',
  validate: (value, [accept]) => {
    if (value.size >= 10485760) {
      return false;
    } else if (accept && accept.indexOf(value.type) < 0) {
      return false;
    } else {
      return true;
    }
  }
});
const config = {
  fieldsBagName: 'fieldBags',
};
Vue.use(VeeValidate, config);

// 二维码插件
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  data: {
    eventBus: new Vue({ methods: {} })
  }
});



// WEBPACK FOOTER //
// ./src/main.js